import * as Preact from "preact"

import "./DiceLayout.less"
import Dice from "@fae/source/data/games/ember/views/Dice.jsx"
import Unit from "@fae/source/models/Unit.js"

export default function DiceLayout() {
    const slotKeys = [0, 1, 2, 3, 4, 5]
    const items = Unit.items({
        "stage": this.props.stage,
        "unit": this.props.unit
    })
    return (
        <div class="DiceLayout">
            {Object.keys(slotKeys).map((slotKey) => {
                const item = items[slotKey]
                return (
                    <Dice item={item ?? null} unit={this.props.unit} stage={this.props.stage}
                        onClick={this.props.onClickSlot}
                        isAnimated={item == this.props.unit.equippedItem}
                        isHighlighted={item == this.props.unit.equippedItem}
                        anchored={this.props.anchored}
                        index={slotKey}/>
                )
            })}
        </div>
    )
}
